import { webxError, webxErrorType } from '@didi/webx-js-core';
// 存储用户通过Webx.initSDK设置的xenv
let _branch;
// 微信设置(公众号)
let _wxConfig = {};
export function getWxConfig() {
    return _wxConfig;
}
export function getBranch() {
    if (!_branch) {
        webxError({
            type: webxErrorType.WEBX_INIT,
            msg: '请先使用webx.initSDK设置环境'
        });
    }
    return _branch;
}
/**
 * initSDK: web sdk初始化
 * @param option
 * @example
 * ```js
 *   initSDK({branch: 'passenger'})
 * ```
 */
export const initSDK = (option) => {
    if (!('branch' in option)) {
        return webxError({
            type: webxErrorType.ENV,
            msg: '没有传入xenv'
        });
    }
    const { branch, wxConfig } = option;
    if (!_branch) {
        _branch = branch;
        _wxConfig = wxConfig || {};
    }
    else if (_branch !== branch) {
        webxError({
            type: webxErrorType.WEBX_INIT,
            msg: `已经设置过xenv为${_branch}，重新设置为${branch}会导致sdk异常`
        });
    }
};
